import HttpClient, {HttpRequestMethods} from '@/infrastructure/api/httpClient'
import ApiResponse from '@/infrastructure/api/apiResponse'
import LocalStorageService from '@/services/localStorageService'
import SessionService from '@/services/sessionService'
import logger from '@/services/loggingService'
import Utils from '@/utils/utils'
import router from '@/router'

const fieldRemap = {
  user: ['id', 'accountUsername', 'thumbPictureUrl'],
  facility: ['id', 'url', 'name', 'logoUrl', 'companyName']
}

const RepositoryService = {

  init () {
    let initialized = false

    this.session = new SessionService()

    try {
      this.session.init()
    } catch (err) {
      logger.error('Error initializing SessionService.')
    }

    this.apiAppId = process.env.APP_ADMIN_ID
    this.apiAppName = process.env.APP_NAME
    // this.apiUrl = initOptions.apiUrl
    // this.culture = initOptions.culture
    // this.devicePlatform = initOptions.devicePlatform
    // this.appVersion = initOptions.appVersion
    this.isSessionExpired = false
    this.onSessionExpired = function () { router.push({ name: 'login' }) }
    // initOptions.onSessionExpired || function () {}
    this.onSessionRestored = function () {}
    // initOptions.onSessionRestored || function () {}
    this.httpClient = new HttpClient({
      'X-MWAPPS-APPID': this.apiAppId,
      'X-MWAPPS-CLIENT': this.apiAppName
    })
    this.session.keepUserLoggedIn = true
    // try {
    // if (this.session.token && this.session.facilityUrl) {
    //   // Try to restore session of logged user.
    //   // TODO: call also api to get list of facilities since
    //   // it's required to switch facility.
    //   const sessionResponses = await Promise.all([
    //     this.restoreLoggedStaff(),
    //     this.loginToFacility(this.session.facilityUrl)
    //   ])

    //   this.session.promptedPermissions = await this.getDevicePromptedPermissions()

    //   if (!sessionResponses[0].hasErrors() && !sessionResponses[1].hasErrors()) {
    //     const staffFacilitiesResponse = await this.restoreLoggedStaffFacilities()

    //     if (!staffFacilitiesResponse.hasErrors()) {
    //       this.session.keepUserLoggedIn = true
    //       this.onSessionRestored(sessionResponses[0].data, sessionResponses[1].data, staffFacilitiesResponse.data)
    //     }
    //   }
    // } else {
    //   await this.session.clear()
    // }

    initialized = true
    // } catch (err) {
    //   logger.error(err)

    //   try {
    //     await this.session.clear()
    //   } catch (err) {
    //     logger.error(err)
    //   }
    // }

    return initialized
  },

  async request (url, method, content, isJsonContent, requestHeaders = {}, cacheData = false, cacheDataExpirationMsec = null) {
    let requestUrl = url
    let requestContent = content || {}
    const ignoreToken = requestUrl.endsWith('/Logout') // For logout service token must not be checked.

    if (this.culture) {
      requestUrl = `${requestUrl}?_c=${this.culture}`
    }

    // Check if response data is in cache.
    let apiResponse = null
    let cachedResponseKey = null
    let cachedReponseData = null

    if (cacheData) {
      // Use request url and request content since response may vary
      // basing on current facility and request parameters and also culture.
      cachedResponseKey = `${requestUrl}|${JSON.stringify(requestContent)}`
      cachedReponseData = LocalStorageService.get(cachedResponseKey)
    }

    if (cachedReponseData) {
      apiResponse = new ApiResponse()
      apiResponse.data = cachedReponseData
      apiResponse.isSessionExpired = false
      apiResponse.errors = null

      if (this.session.token) {
        apiResponse.token = this.session.token
      }
    } else {
      // if (this.session.token) {
      //   requestHeaders.Authorization = `Bearer ${this.session.token}`
      // }

      let httpResponse

      try {
        httpResponse = await this.httpClient.send(requestUrl, method, requestHeaders, requestContent, isJsonContent)
      } catch (err) {
        httpResponse = err
      }

      apiResponse = new ApiResponse(httpResponse)
    }

    if (!ignoreToken) {
      if (apiResponse.isSessionExpired) {
        // Token expired.
        // Use isSessionExpired flag to notify only once if token has expired.
        // Without this flag, if multiple api are called at the same time,
        // onTokenExpired would be called more than once.

        if (!this.isSessionExpired) {
          this.isSessionExpired = true

          this.session.clearToken()

          this.onSessionExpired()
        }
      } else {
        // Token is valid and it has been renewed.
        this.isSessionExpired = false

        if (apiResponse.token) {
          this.session.setToken(apiResponse.token)
        }

        // if (cacheData && !cachedReponseData && !apiResponse.hasErrors() && apiResponse.data) {
        //   LocalStorageService.set(cachedResponseKey, apiResponse.data, cacheDataExpirationMsec)
        // }
      }
    }

    return apiResponse
  },

  getDefaultHeader () { return {'X-MWAPPS': `${this.apiAppId}|${this.session.token}|${this.session.selectedBillingCompany.url}`} },

  async loginAdmin (username, password, rememberme) {
    const requestUrl = `/Application/${process.env.APP_ADMIN_ID}/Login`
    const requestContent = {username: username, password: password}

    const loginResponse = await this.request(requestUrl, HttpRequestMethods.post, requestContent, true)

    if (!loginResponse.hasErrors()) {
      this.session.setUser(Utils.remapObject(loginResponse.data.userContext, fieldRemap.user))
      this.session.setBillingCompanies(loginResponse.data.facilities.map(Utils.remapArrayObject(fieldRemap.facility)).sort(Utils.orderArrayObjectByFieldAlphabeticalAsc('name')))
      this.session.staff = null
      if (rememberme) {
        this.session.setRememberme()
      }
    }

    return loginResponse
  },

  async loginAdminFacility (selectedBillingCompany) {
    const requestUrl = `/Application/${process.env.APP_ADMIN_ID}/GetCurrentOperatorContext`
    const requestContent = {clientIpAddress: 'mwc_ips_white_list', token: `${this.session.token}`}
    const requestHeader = {'X-MWAPPS': `${this.apiAppId}|${this.session.token}|${selectedBillingCompany.url}`}

    const loginResponse = await this.request(requestUrl, HttpRequestMethods.post, requestContent, true, requestHeader)

    if (!loginResponse.hasErrors()) {
      this.session.setselectedBillingCompany(Utils.remapObject(selectedBillingCompany, fieldRemap.facility))
      this.session.setUserPermissions(loginResponse.data)
    }

    return loginResponse
  },

  async createIntegrator (name, trustedDomains) {
    const requestUrl = `/Admin/1/CreateIntegrator`
    const requestContent = {name: name, trustedDomains: trustedDomains, token: `${this.session.token}`}

    return this.request(requestUrl, HttpRequestMethods.post, requestContent, true)
  },

  async createTestFacility (requestContent) {
    const requestUrl = `/Admin/1/CreateTestFacility`
    requestContent.token = `${this.session.token}`

    return this.request(requestUrl, HttpRequestMethods.post, requestContent, true, this.getDefaultHeader())
  },

  async createTestChain (requestContent) {
    const requestUrl = `/Admin/1/CreateTestChain`
    requestContent.token = `${this.session.token}`

    return this.request(requestUrl, HttpRequestMethods.post, requestContent, true, this.getDefaultHeader())
  },

  async saveFacilitiesForChain (chainId, requestContent) {
    const requestUrl = `/Core/Chain/${chainId}/SaveFacilitiesForChain`
    requestContent.token = `${this.session.token}`

    return this.request(requestUrl, HttpRequestMethods.post, requestContent, true, this.getDefaultHeader())
  },

  async setAccountKind (requestContent) {
    const requestUrl = `/Admin/1/SetAccountKind`
    requestContent.token = `${this.session.token}`
    return this.request(requestUrl, HttpRequestMethods.post, requestContent, true)
  },

  async staffDetails (staffId, requestContent) {
    const requestUrl = `/Core/Staff/${staffId}/Details`
    requestContent.token = `${this.session.token}`

    return this.request(requestUrl, HttpRequestMethods.post, requestContent, true, this.getDefaultHeader())
  },

  async getIntegrators () {
    const requestUrl = `/Application/${process.env.APP_ADMIN_ID}/GetIntegrators`

    return this.request(requestUrl, HttpRequestMethods.post, {}, true, this.getDefaultHeader())
  },

  async getLists () {
    const requestUrl = `/Application/${process.env.APP_ADMIN_ID}/Lists`

    return this.request(requestUrl, HttpRequestMethods.post, {}, true, this.getDefaultHeader())
  },

  async getIntegratorInfo () {
    const requestUrl = `/Core/Facility/${this.session.selectedFacility ? this.session.selectedFacility.id : this.session.selectedBillingCompany.id}/GetIntegrationInfo`

    return this.request(requestUrl, HttpRequestMethods.post, {}, true, this.getDefaultHeader())
  },

  async searchFacilities (requestContent) {
    const requestUrl = `/Core/BillingCompany/${this.session.selectedBillingCompany.id}/SearchFacilities`

    return this.request(requestUrl, HttpRequestMethods.post, requestContent, true, this.getDefaultHeader())
  },

  async updateFacility (requestContent) {
    const requestUrl = `/Core/Facility/${this.session.selectedFacility.id}/Update`

    return this.request(requestUrl, HttpRequestMethods.post, requestContent, true, this.getDefaultHeader())
  },

  async updateChain (requestContent) {
    const requestUrl = `/Core/Chain/${this.session.selectedFacility.id}/Update`

    return this.request(requestUrl, HttpRequestMethods.post, requestContent, true, this.getDefaultHeader())
  },

  async facilityDetails (facilityId) {
    const requestUrl = `/Core/Facility/${facilityId}/Details`

    return this.request(requestUrl, HttpRequestMethods.post, {}, true, this.getDefaultHeader())
  },

  async chainDetails (facilityId) {
    const requestUrl = `/Core/Facility/${facilityId}/StatusDetails`

    return this.request(requestUrl, HttpRequestMethods.post, {}, true, this.getDefaultHeader())
  },

  async searchChains (requestContent) {
    const requestUrl = `/Core/BillingCompany/${this.session.selectedBillingCompany.id}/SearchChains`

    return this.request(requestUrl, HttpRequestMethods.post, requestContent, true, this.getDefaultHeader())
  },

  async searchFacilitiesByChain (requestContent) {
    const requestUrl = `/Application/${process.env.APP_ADMIN_ID}/SearchFacilitiesByChain`

    return this.request(requestUrl, HttpRequestMethods.post, requestContent, true, this.getDefaultHeader())
  },

  async deleteIntegration (requestContent) {
    const requestUrl = `/Core/Facility/${this.session.selectedFacility.id}/DeleteIntegrationInfo`

    return this.request(requestUrl, HttpRequestMethods.post, requestContent, true, this.getDefaultHeader())
  },

  async saveIntegrationInfo (requestContent) {
    const requestUrl = `/Core/Facility/${this.session.selectedFacility.id}/SaveIntegrationInfo`

    return this.request(requestUrl, HttpRequestMethods.post, requestContent, true, this.getDefaultHeader())
  },

  async searchStaffs (requestContent) {
    const requestUrl = `/Core/Facility/${this.session.selectedFacility.id}/SearchStaffs`

    return this.request(requestUrl, HttpRequestMethods.post, requestContent, true, this.getDefaultHeader())
  },

  async deleteStaff (staffId) {
    const requestUrl = `/Core/Staff/${staffId}/Delete`

    return this.request(requestUrl, HttpRequestMethods.post, {}, true, this.getDefaultHeader())
  },

  async searchUsersByOperator (requestContent) {
    const requestUrl = `/Application/${process.env.APP_ADMIN_ID}/SearchUsersByOperator`
    requestContent.token = `${this.session.token}`
    return this.request(requestUrl, HttpRequestMethods.post, requestContent, true, this.getDefaultHeader())
  },

  async createStaffMemberFromUser (requestContent) {
    const requestUrl = `/Core/Facility/${this.session.selectedFacility.id}/CreateStaffMemberFromUser`
    requestContent.token = `${this.session.token}`
    return this.request(requestUrl, HttpRequestMethods.post, requestContent, true, this.getDefaultHeader())
  },

  async getFacilitiesWithIntegration (requestContent) {
    const requestUrl = `/Admin/1/FacilitiesWithIntegration`
    requestContent.token = `${this.session.token}`
    return this.request(requestUrl, HttpRequestMethods.post, requestContent, true)
  }

}

export default RepositoryService
